export default __webpack_public_path__ + "static/media/AIPStatusAAP.6331deb8.png";